<template>
  <div class="w-full flex flex-col p-2 grow pt-0 overflow-auto">
    <div
      v-for="(item, index) in links"
      :key="item.link"

      class="relative bg-white py-2 px-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 hover:bg-gray-50"
    >
      <div class="flex justify-between space-x-3">
        <div class="min-w-0 flex-1">
          <a href="#" class="block focus:outline-none">
            <p class="truncate text-sm font-medium text-gray-900">{{ item.name }}</p>
            <a class="truncate text-sm text-gray-500 underline cursor-pointer hover:text-gray-800" target="_blank" :href="linkPrefix + item.link">{{ item.link }}</a>
          </a>
        </div>
        <span @click.stop="remove(index)" class="cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-400 hover:text-red-500 w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </span>
      </div>
    </div>

    <NewProductPage @create-catalog-link="save"/>
  </div>
</template>

<script>

/*
id: Product list custom url generator ProductList_1664998079440
title: Product list
role: catalog-products
config: { "variant": null, "default_sort": "price&desc" }

configuration: { "id": "custom_urls", "component": "ProductListCustomUrlGenerator", "portal": true, "default": [] }
* * */

import NewProductPage from "./NewProductPage"
import { mapGetters } from "vuex"

export default {
  components: { NewProductPage },
  props: ['id', 'title', 'role', 'config', 'content', 'configuration'],
  computed: {
    ...mapGetters({
      fullLink: 'editor/fullDomainLink',
    }),
    linkPrefix() {
      return `${this.fullLink}/all?`
    },

    links() {
      return this.config[this.configuration.id] || []
    },
  },
  methods: {
    remove(index) {
      const links = this.links.slice()
      links.splice(index, 1)
      this.updateConfig(links)
    },
    updateConfig(links) {
      const config = { ...this.config }
      config[this.configuration.id] = links

      this.$store.dispatch('editor/setBlockConfig', {
        id: this.id,
        role: this.role,
        config,
      })
    },
    save({ link, name }) {
      this.updateConfig([ ...this.links, { link, name } ])
    },
  },
}

</script>
